import subscriptionTrialConfig from './subscriptionTrialConfig.json';

export const DEFAULT_TRIAL_DAYS = subscriptionTrialConfig.days;

const getProtectedProfileData = user => user?.attributes?.profile?.protectedData || {};
const getPrivateProfileData = user => user?.attributes?.profile?.privateData || {};

export const hasTrialHistory = user => {
  const privateData = getPrivateProfileData(user);
  return Boolean(
    privateData?.hasTrialStarted || privateData?.trialCreationDate || privateData?.trialExpirationDate
  );
};

export const hasSubscriptionHistory = user => {
  const protectedData = getProtectedProfileData(user);
  const privateData = getPrivateProfileData(user);
  const subscriptionData = privateData?.subscriptionData;
  const currentPeriodEnd = Number(subscriptionData?.current_period_end);

  return Boolean(
    privateData?.stripeSubscriptionId ||
      subscriptionData?.id ||
      (Number.isFinite(currentPeriodEnd) && currentPeriodEnd > 0) ||
      privateData?.hasSubscribed ||
      protectedData?.hasSubscribed
  );
};

export const isEligibleForTrialCheckout = user => {
  // Unknown/anonymous users are treated as eligible on frontend;
  // backend performs the final eligibility check.
  if (!user?.id) {
    return true;
  }

  return !hasTrialHistory(user) && !hasSubscriptionHistory(user);
};

export const getTrialChargeDateFromSubscription = subscription => {
  const trialEnd = Number(subscription?.trial_end);
  if (!Number.isFinite(trialEnd) || trialEnd <= 0) {
    return null;
  }

  return new Date(trialEnd * 1000);
};

export const isSubscriptionTrialing = subscription => {
  if (!subscription || typeof subscription !== 'object') {
    return false;
  }

  const trialChargeDate = getTrialChargeDateFromSubscription(subscription);
  return subscription?.status === 'trialing' || Boolean(trialChargeDate && trialChargeDate.getTime() > Date.now());
};
